module.exports = __WEBPACK_EXTERNAL_MODULE__96966__;